module.exports = __webpack_public_path__ + "img/cash.fa1af509.svg";